import { IonBackButton, IonButtons, IonCardContent, IonContent, IonHeader, IonLoading, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react"
import { arrowBackCircleSharp } from "ionicons/icons"
import { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ApplicationContext } from "../../ApplicationState";
import * as ApiService from "../../services/ApiService";
// import 'tabulator-tables/dist/css/tabulator.min.css';
// import 'survey-analytics/survey.analytics.tabulator.min.css';
import * as SurveyAnalytics from "survey-analytics";
import { Tabulator } from 'survey-analytics/survey.analytics.tabulator';
import { Model } from "survey-core";
import { PlotlySetup, VisualizationPanel, VisualizerBase } from "survey-analytics";
import "survey-analytics/survey.analytics.css";
import { Button, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, getCardHeaderUtilityClass, ThemeProvider, Typography } from "@mui/material";
import MaterialTable from "material-table";
import Header from "../../components/Header/Header";
import tableIcons from "../../components/Notifications/MaterialTableIcons";

var _ = require("lodash");

export const UserScheduleResponse = () => {
    const location: any = useLocation();
    const defaultMaterialTheme = createTheme()
    const tableRef = useRef(null)
    const analyticsContainer = useRef(null);

    const [userData, setUserData] = useState([])

    const groupsColumns = [
        {
            field: "scheduleName",
            title: "Schedule Name",
            cellStyle: {
                width: '40%',
            },
        },

        {
            field: "responseAnswer",
            title: "Response",
        },
    ];

    useEffect(() => {
        if (location?.state) {
            setUserData(location?.state?.userScheduleResponses)
        }
    }, [])

    return (
        <IonPage>
            {/* <Header /> */}
            <IonHeader>
                <IonToolbar color="light">
                    <IonButtons slot="start">
                        <IonBackButton
                            text="Go Back"
                            icon={arrowBackCircleSharp}
                            defaultHref="/"
                        />
                    </IonButtons>
                    <IonTitle>Schedule Responses</IonTitle>
                </IonToolbar>
            </IonHeader>
            {_.isEmpty(location.state) ? (
                <CircularProgress
                    size={24}
                    sx={{
                        color: "#3880ff",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                    }}
                />
            ) : (
                <IonContent>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            tableRef={tableRef}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: (
                                        <Typography>
                                            No Responses to display
                                        </Typography>
                                    ),
                                },
                            }}
                            style={{ width: "100%" }}
                            title=""
                            icons={tableIcons}
                            columns={groupsColumns}
                            options={{
                                pageSizeOptions: [5, 10],
                                defaultExpanded: true,
                            }}

                            components={{
                                OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> Loading... </div>)
                            }}
                            page={5}
                            data={userData === null ? [] : userData}

                        />
                    </ThemeProvider>

                    <div>
                        <div className="sa-question__select" ref={analyticsContainer} style={{ width: "100%", height: "600px" }}></div>
                    </div>
                </IonContent>
            )
            }
        </IonPage>
    )
}